module.exports = __webpack_public_path__ + "img/download.c8af23cd.svg";